// extracted by mini-css-extract-plugin
export default {"ErrorPage":"ErrorPage_ErrorPage__XUKo0","ErrorIcon":"ErrorPage_ErrorIcon__F3Wai"};